import { render, staticRenderFns } from "./MyWork.vue?vue&type=template&id=1f3c9d01&"
import script from "./MyWork.vue?vue&type=script&lang=js&"
export * from "./MyWork.vue?vue&type=script&lang=js&"
import style0 from "./MyWork.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports